import { storage } from './storage';

export const getLeadChannelFromStorage = () => {
  return storage.get('leadChannel');
};
